






































import { Component, Prop } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import suppliers from "@/views/supplier/supplier.vue";

// 表单类型定义
class CheckObj {
  supplierId: number = 0;
}

@Component({
  components: {},
})
export default class SelectedModal extends AbpBase {
  // ==================== Prop 定义（修复类型错误）====================
  // 弹窗显示隐藏（v-model 绑定）
  @Prop({ type: Boolean, default: false })
  value!: boolean;

  // 父组件传入的 ID（数字类型，解决你报的类型错误）
  @Prop({ type: Number, default: 0 })
  supplierOfferId: number;
  @Prop({ type: Number, default: 0 })
  supplierId: number;

  // ==================== 数据定义 ====================
  title: string = "修改供应商";
  checkObj: CheckObj = new CheckObj();
  supplierList: Array<suppliers> = [];

  supplierOfferRule = {
    supplierId: [
      {
        required: true,
        validator: this.checkSupplierId,
        trigger: "change",
      },
    ],
  };

  checkSupplierId(rule: any, value: any, callback: any) {
    if (!this.checkObj.supplierId) {
      callback(new Error("请选择供应商"));
    } else {
      callback();
    }
  }

  // ==================== 方法 ====================
  // 保存
  save() {
    // 组装提交数据
    const submitData = {
      id: this.supplierOfferId,
      supplierId: this.checkObj.supplierId,
    };

    // 表单验证
    (this.$refs.supplierOfferForm as any).validate(async (valid: boolean) => {
      // 验证不通过直接返回
      if (!valid) return;
      try {
        // 调用 vuex 更新数据
        await this.$store.dispatch({
          type: "supplierOffer/updateSupplierIdById",
          data: submitData,
        });
        // 成功提示
        this.$Message.success("修改供应商成功");

        // 触发父组件事件
        this.$emit("input", false);

        this.$emit("save-success");
      } catch (err) {
        this.$Message.error("修改失败，请重试");
        console.error(err);
      } finally {
        // 无论成功失败，关闭弹窗 + 重置表单
        (this.$refs.supplierOfferForm as any).resetFields();
        this.$emit("input", false);
      }
    });
  }
  // 取消
  cancel() {
    this.$emit("input", false);
  }
  async getSupplierList() {
    return await this.$store
      .dispatch({
        type: "supplier/GetAllSupplierListLabelAndValue",
      })
      .then((res) => {
        if (res && res.data && res.data.result) {
          this.supplierList = res.data.result;
        }
      });
  }
  // 弹窗显示/隐藏 事件
  async visibleChange(visible: boolean) {
    if (!visible) {
      this.$emit("input", visible);
      return;
    } else {
      if (this.$props.supplierId) {
        this.checkObj.supplierId = this.$props.supplierId;
        await this.getSupplierList();
      } else {
        this.$Message.error("未获取到供应商信息，请重试");
      }
    }
  }
}
